import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { routes } from '@const/routes';
import styles from './styles.module.scss';
import Typography from '@components/common/typography';
import { useAmlAlerts } from '@hooks/api/useAmlAlerts';
import { Icon } from '@components/icons';
import { useBack } from '@hooks/helpers/useBack';
import { useGlobalContext } from '@hooks/context/useGlobalContext';
import DataInfo from '@components/data_info';
import FormField from '@components/form_field';
import Input from '@components/common/input';
import { useForm } from '@hooks/helpers/useForm';
import moment from 'moment/moment';

const AmlAlertLayout = () => {
    const { id } = useParams<{ id: string }>();
    const { handleNavigateBack } = useBack();
    const { handleChangeBackLabel } = useGlobalContext();
    const form = useForm({});

    const { alert } = useAmlAlerts({ isInitialAlert: true });

    useEffect(() => {
        handleChangeBackLabel({ label: 'AML Alerts', route: routes.aml_alerts });
        return () => {
            handleChangeBackLabel({ label: '', route: '' });
        };
    }, [id]);

    useEffect(() => {
        if (alert) {
            form.reset({
                id: alert.id,
                alert_type: alert.alert_type || '',
                severity: alert.severity || '',
                status: alert.status || '',
                party_id: alert.party_id || '',
                amount: alert.amount ? `${alert.amount} ${alert.currency || ''}`.trim() : '',
                created_at: alert.created_at
                    ? moment(alert.created_at).format('MM.DD.YYYY HH:mm:ss')
                    : '',
                updated_at: alert.updated_at
                    ? moment(alert.updated_at).format('MM.DD.YYYY HH:mm:ss')
                    : '',
                rule_code: alert.rule_code || '',
                detail: alert.detail || ''
            });
        }
    }, [alert]);

    return (
        <div className={styles.wrapper}>
            <button onClick={handleNavigateBack} className="back">
                <Icon name="arrow_left" width={16} height={16} />
                Back
            </button>
            <div className={styles.header}>
                <div className={styles.text_wrapper}>
                    <Typography variant="h4">AML Alert</Typography>
                </div>
            </div>
            <div className={styles.content}>
                <DataInfo label="Alert Information" form={form}>
                    <FormField
                        name="id"
                        renderComponent={(props) => <Input readOnly full {...props} label="ID" />}
                    />
                    <FormField
                        name="alert_type"
                        renderComponent={(props) => (
                            <Input readOnly full {...props} label="Type" />
                        )}
                    />
                    <FormField
                        name="severity"
                        renderComponent={(props) => (
                            <Input readOnly full {...props} label="Severity" />
                        )}
                    />
                    <FormField
                        name="status"
                        renderComponent={(props) => (
                            <Input readOnly full {...props} label="Status" />
                        )}
                    />
                    <FormField
                        name="party_id"
                        renderComponent={(props) => (
                            <Input readOnly full {...props} label="Party ID" />
                        )}
                    />
                    <FormField
                        name="amount"
                        renderComponent={(props) => (
                            <Input readOnly full {...props} label="Amount" />
                        )}
                    />
                    <FormField
                        name="created_at"
                        renderComponent={(props) => (
                            <Input readOnly full {...props} label="Created" />
                        )}
                    />
                    <FormField
                        name="updated_at"
                        renderComponent={(props) => (
                            <Input readOnly full {...props} label="Updated" />
                        )}
                    />
                </DataInfo>
                <DataInfo label="Rule Details" form={form}>
                    <FormField
                        name="rule_code"
                        renderComponent={(props) => (
                            <Input readOnly full {...props} label="Rule Code" />
                        )}
                    />
                    <FormField
                        name="detail"
                        renderComponent={(props) => (
                            <Input readOnly full {...props} label="Detail" />
                        )}
                    />
                </DataInfo>
            </div>
        </div>
    );
};

export default AmlAlertLayout;
